import TeamOverViewDetail from './TeamOverviewDetail';

export default TeamOverViewDetail;
